import type { FC } from 'react';

import { cn } from '@wwe-portal/ui/lib/lib';

export const NotifPip: FC<{ className?: string }> = ({ className }) => {
  return (
    <div className={cn('absolute -right-1.5 -top-1.5 z-10 h-4 w-4', className)}>
      <div className="absolute inset-0 rounded-full border border-solid border-[#E287B3] bg-[#EE2970]" />
      <div className="absolute inset-0 animate-ping rounded-full bg-[#E287B3]" />
    </div>
  );
};
